import { IndexCardStack } from './index-card-stack';
import { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { MasterKushStrainIndexCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/index-cards-3x5/master-kush-strain-index-card-stack-content/master-kush-strain-index-card-stack-content.component';
import { MasterKushStrainIndexCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/index-cards-3x5/master-kush-strain-index-card-stack-background/master-kush-strain-index-card-stack-background.component';

export class MasterKushStrainIndexCardStack extends IndexCardStack {
  getCardHeightInInches(): number {
    return 3.08;
  }

  getCardWidthInInches(): number {
    return 5.12;
  }

  getCardBackgroundComponent(data: CardData): Type<CardBackgroundComponent> | null {
    return MasterKushStrainIndexCardStackBackgroundComponent;
  }

  getCardContentComponent(data: CardData): Type<PrintCardContentComponent> | null {
    return MasterKushStrainIndexCardStackContentComponent;
  }

  nonPerforatedBleedBorderInInches(): number {
    return 0;
  }
}
